export default __webpack_public_path__ + "static/media/man-team-2.63938841.avif";